module.exports = __webpack_public_path__ + "static/media/tombstone-alt.0ad9f701.svg";